var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 927 618",
    width: 920,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Not_found-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 362.3,
    y1: 314.4,
    x2: 362.3,
    y2: 280.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.4
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: #c0ccd8 } \n\t\t.s1 { fill: none;stroke: #c0ccd8;stroke-linejoin: round } \n\t\t.s2 { fill: none;stroke: #c0ccd8;stroke-width: 3 } \n\t\t.s3 { fill: #ffffff;stroke: #c0ccd8;stroke-linejoin: round } \n\t\t.s4 { fill: #30c1d9 } \n\t\t.s5 { fill: #c0ccd8 } \n\t\t.s6 { fill: none;stroke: #c0ccd8;stroke-linecap: round;stroke-linejoin: round } \n\t\t.s7 { fill: #475577 } \n\t\t.s8 { fill: #717a91 } \n\t\t.s9 { fill: none;stroke: #544943;stroke-width: 1.5 } \n\t\t.s10 { fill: #8e9db2 } \n\t\t.s11 { fill: #ffcbbb } \n\t\t.s12 { fill: #e6e8ef } \n\t\t.s13 { fill: #0f1e42 } \n\t\t.s14 { fill: none;stroke: #846a6a } \n\t\t.s15 { fill: #173789 } \n\t\t.s16 { fill: #fca32d } \n\t\t.s17 { fill: none;stroke: #ce680d } \n\t\t.s18 { fill: #ffb548 } \n\t\t.s19 { fill: none;stroke: #ed841b } \n\t\t.s20 { fill: none;stroke: #ed841b;stroke-dasharray: 3 } \n\t\t.s21 { fill: none;stroke: #846a6a;stroke-linejoin: round } \n\t\t.s22 { fill: #ffffff } \n\t\t.s23 { fill: none;stroke: #ef977f } \n\t\t.s24 { fill: #c8e8f5 } \n\t\t.s25 { fill: #f2f5f9 } \n\t\t.s26 { fill: #e7eaf2 } \n\t\t.s27 { opacity: .5;fill: #8e9db2 } \n\t\t.s28 { fill: #c6d2e0 } \n\t\t.s29 { fill: url(#g1) } \n\t\t.s30 { fill: #e8eaef } \n\t\t.s31 { fill: none;stroke: #475577;stroke-width: 2 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m460.6 99.8v84.4c0 2.2-1.8 4-4 4h-145c-2.2 0-4-1.8-4-4v-84.4c0-2.2 1.8-4 4-4h145c2.2 0 4 1.8 4 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m307.6 112.5h153"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m315.1 104.3c0-1.4 1-2.5 2.4-2.5 1.4 0 2.4 1.1 2.4 2.5 0 1.3-1 2.4-2.4 2.4-1.4 0-2.4-1.1-2.4-2.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m330 104.3q0 0.7-0.4 1.3-0.4 0.6-1.1 0.9c-0.5 0.2-1 0.3-1.4 0.2-0.5-0.1-1-0.4-1.3-0.7q-0.5-0.5-0.7-1.3-0.1-0.7 0.2-1.4c0.1-0.4 0.5-0.8 0.9-1.1q0.6-0.4 1.3-0.4c0.7 0 1.3 0.2 1.8 0.7 0.4 0.5 0.7 1.1 0.7 1.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m340.1 104.3q0 0.7-0.4 1.3c-0.3 0.4-0.7 0.8-1.2 0.9-0.4 0.2-0.9 0.3-1.4 0.2q-0.7-0.2-1.2-0.7-0.6-0.5-0.7-1.3c-0.1-0.4-0.1-0.9 0.1-1.4 0.2-0.4 0.5-0.8 0.9-1.1 0.4-0.3 0.9-0.4 1.4-0.4 0.7 0 1.3 0.2 1.7 0.7 0.5 0.5 0.8 1.1 0.8 1.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m269.9 155.4v36.1c0 3.5-2.9 6.3-6.3 6.3h-36.2c-3.5 0-6.3-2.8-6.3-6.3v-36.1c0-3.5 2.8-6.4 6.3-6.4h36.2c3.4 0 6.3 2.9 6.3 6.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m231.5 173.4c0-7.7 6.3-13.9 14-13.9 7.7 0 14 6.2 14 13.9 0 7.8-6.3 14-14 14-7.7 0-14-6.2-14-14z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m254.9 163.6l-19.7 19.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m593.6 186.7l-10.1-10.4h-155.8c-1.8 0-3.5-0.4-5.1-1.1-1.6-0.6-3.1-1.6-4.3-2.8-1.2-1.2-2.2-2.7-2.8-4.3-0.7-1.6-1-3.3-1-5v-81.1c0-3.5 1.3-6.8 3.8-9.3 2.5-2.5 5.9-3.9 9.4-3.9h156.4c3.5 0 6.9 1.4 9.4 3.9 2.5 2.5 3.8 5.8 3.8 9.3v103.2q0 0.7-0.3 1.3-0.4 0.5-1 0.8-0.6 0.2-1.3 0.1-0.7-0.2-1.1-0.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s4",
    d: "m477.1 140h-6.7v11.8h-16.3v-11.8h-24.3v-12l25.3-37.1h15.2v36.8h6.8zm-23-12.2v-7.1c0-1.3 0-3.2 0.2-5.4q0-1.8 0.2-3.6h-0.4q-1.4 3.1-3.2 6l-6.8 10.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s4",
    d: "m527.8 121.4q0 16.2-5.4 23.7-5.5 7.5-16.6 7.5-10.9 0-16.5-7.8-5.5-7.9-5.5-23.4 0-16.2 5.4-23.8 5.4-7.5 16.6-7.5 10.8 0 16.4 7.9 5.6 7.9 5.6 23.4zm-27.6 0c0 6.9 0.4 11.7 1.2 14.3 0.8 2.5 2.3 3.8 4.3 3.8q3.1 0 4.4-4c0.8-2.6 1.2-7.4 1.2-14.1 0-6.6-0.4-11.4-1.2-14.1-0.8-2.7-2.3-4.1-4.3-4.1-2.1 0-3.5 1.3-4.4 3.9-0.8 2.7-1.2 7.4-1.2 14.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s4",
    d: "m581.9 140h-6.7v11.8h-16.2v-11.8h-24.3v-12l25.3-37.1h15.2v36.8h6.7zm-22.9-12.2v-7.1c0-1.3 0-3.2 0.1-5.4q0-1.8 0.3-3.6h-0.5q-1.4 3.1-3.2 6l-6.8 10.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m782.9 297.5v36.2c0 3.5-2.8 6.3-6.3 6.3h-36.2c-3.5 0-6.3-2.8-6.3-6.3v-36.2c0-3.5 2.8-6.3 6.3-6.3h36.2c3.5 0 6.3 2.8 6.3 6.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m774.2 329.3q-0.2 0.1-0.5 0.1h-30.3q-0.5 0-0.9-0.2-0.4-0.3-0.7-0.7-0.2-0.4-0.2-0.9 0-0.5 0.2-0.9l15.2-26.2q0.2-0.4 0.6-0.7 0.4-0.2 0.9-0.2 0.5 0 0.9 0.2 0.4 0.3 0.6 0.7l15.2 26.2q0.2 0.4 0.2 0.8 0.1 0.4-0.1 0.7-0.1 0.4-0.4 0.7-0.3 0.3-0.7 0.4zm-30-2.2h28.6l-14.3-24.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m758.5 321.9q-0.4 0-0.7-0.3-0.3-0.3-0.4-0.7l-0.6-10.3q0-0.4 0.1-0.7 0.1-0.3 0.4-0.5 0.2-0.3 0.5-0.4 0.3-0.2 0.7-0.2 0.3 0 0.7 0.2 0.3 0.1 0.5 0.3 0.3 0.3 0.4 0.6 0.1 0.3 0.1 0.7l-0.6 10.3q0 0.4-0.4 0.7-0.3 0.3-0.7 0.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m759.6 324.4q0 0.4-0.2 0.6-0.2 0.3-0.5 0.4-0.3 0.2-0.6 0.1-0.3-0.1-0.6-0.3-0.2-0.2-0.3-0.6 0-0.3 0.1-0.6 0.1-0.3 0.4-0.5 0.3-0.2 0.6-0.2 0.2 0 0.4 0.1 0.2 0.1 0.4 0.3 0.1 0.1 0.2 0.3 0.1 0.2 0.1 0.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m119.2 252.8c0 0.5-0.2 1-0.5 1.5-0.3 0.4-0.7 0.8-1.2 1-0.5 0.2-1.1 0.3-1.6 0.2-0.5-0.1-1-0.4-1.4-0.8-0.4-0.4-0.7-0.9-0.8-1.4-0.1-0.5 0-1.1 0.2-1.6 0.2-0.5 0.6-0.9 1-1.2 0.5-0.3 1-0.5 1.5-0.5 0.8 0 1.5 0.3 2 0.8 0.5 0.5 0.8 1.2 0.8 2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m581.9 399.6c0 0.6-0.1 1.1-0.4 1.5-0.3 0.5-0.8 0.9-1.3 1.1-0.5 0.2-1 0.2-1.6 0.1-0.5-0.1-1-0.3-1.4-0.7-0.4-0.4-0.6-0.9-0.7-1.4-0.1-0.6-0.1-1.1 0.1-1.6 0.2-0.5 0.6-1 1-1.3 0.5-0.3 1-0.4 1.6-0.4 0.7 0 1.4 0.3 1.9 0.8 0.5 0.5 0.8 1.2 0.8 1.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m771.2 173.4c0 0.6-0.2 1.1-0.5 1.6-0.3 0.4-0.7 0.8-1.2 1-0.5 0.2-1.1 0.3-1.6 0.2-0.5-0.2-1-0.4-1.4-0.8-0.4-0.4-0.7-0.9-0.8-1.4-0.1-0.5 0-1.1 0.2-1.6 0.2-0.5 0.5-0.9 1-1.2 0.5-0.3 1-0.5 1.5-0.5 0.8 0 1.5 0.3 2 0.8 0.5 0.5 0.8 1.2 0.8 1.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m622.5 88.3c0 0.5-0.1 1-0.4 1.5-0.3 0.4-0.8 0.8-1.3 1-0.5 0.2-1 0.3-1.6 0.2-0.5-0.1-1-0.4-1.4-0.8-0.4-0.4-0.6-0.9-0.7-1.4-0.1-0.5-0.1-1.1 0.1-1.6 0.2-0.5 0.6-0.9 1-1.2 0.5-0.3 1-0.5 1.6-0.5 0.7 0 1.4 0.3 1.9 0.8 0.5 0.5 0.8 1.2 0.8 2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m765.7 263.5v8.5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m770 267.8h-8.6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m542.7 427.8v8.6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m547 432.1h-8.5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m362.3 72.5v8.6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m366.6 76.8h-8.5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m171.4 155v8.5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m175.7 159.2h-8.5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m157.5 351.3v8.6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m161.8 355.6h-8.5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m641 120.8v8.5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m645.3 125.1h-8.6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m221 302.8h-85.3c-0.8 0-1.4-0.3-2-0.8-0.5-0.5-0.7-1.2-0.7-1.9 0-0.7 0.2-1.4 0.7-1.9 0.5-0.5 1.2-0.8 2-0.8h85.3c0.7 0 1.4 0.3 1.9 0.8 0.5 0.5 0.8 1.2 0.8 1.9 0 0.7-0.3 1.4-0.8 1.9-0.5 0.5-1.2 0.8-1.9 0.8z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m723.5 234.6h-85.3c-0.7 0-1.4-0.3-1.9-0.8-0.5-0.5-0.8-1.2-0.8-1.9q0-0.5 0.2-1 0.2-0.5 0.6-0.9 0.4-0.4 0.9-0.6 0.5-0.2 1-0.2h85.3c0.7 0 1.4 0.3 1.9 0.8 0.5 0.5 0.8 1.2 0.8 1.9 0 0.7-0.3 1.4-0.8 1.9-0.5 0.5-1.2 0.8-1.9 0.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m736 252.8h-31.5c-0.3 0-0.7-0.2-0.9-0.4-0.3-0.3-0.4-0.6-0.4-1 0-0.3 0.1-0.7 0.4-0.9 0.2-0.3 0.6-0.4 0.9-0.4h31.6q0.2 0 0.5 0.1 0.2 0.1 0.4 0.3 0.2 0.1 0.3 0.4 0.1 0.2 0.1 0.5 0 0.3-0.1 0.5-0.1 0.3-0.3 0.5-0.2 0.2-0.5 0.3-0.2 0.1-0.5 0.1z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m652.5 188.5h-31.5q-0.3 0-0.6-0.2-0.2-0.1-0.4-0.2-0.2-0.2-0.3-0.5-0.1-0.2-0.1-0.5c0-0.4 0.2-0.7 0.4-1 0.3-0.2 0.6-0.4 1-0.4h31.5c0.4 0 0.7 0.2 1 0.4 0.2 0.3 0.4 0.6 0.4 1q0 0.3-0.1 0.5-0.1 0.3-0.3 0.5-0.2 0.1-0.5 0.2-0.2 0.2-0.5 0.2z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m189.3 278.9h-24.2q-0.2 0-0.5-0.1-0.2-0.1-0.4-0.3-0.2-0.2-0.3-0.4-0.1-0.3-0.1-0.5c0-0.4 0.1-0.7 0.4-1 0.2-0.2 0.6-0.4 0.9-0.4h24.2c0.3 0 0.7 0.2 0.9 0.4 0.3 0.3 0.4 0.6 0.4 1q0 0.2-0.1 0.5-0.1 0.2-0.3 0.4-0.2 0.2-0.4 0.3-0.3 0.1-0.5 0.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m671.8 155.2v-26.1c0-2.5 2.1-4.6 4.6-4.6h26.1c2.6 0 4.6 2.1 4.6 4.6v26.1c0 2.5-2 4.6-4.6 4.6h-26.1c-2.5 0-4.6-2.1-4.6-4.6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m694.5 140.7l-0.6 3h3.3v2.7h-3.8l-1 5.3h-2.9l1-5.3h-3.7l-1 5.3h-2.8l1-5.3h-3.1v-2.7h3.6l0.6-3h-3.3v-2.8h3.7l1-5.3h2.9l-1 5.3h3.7l1-5.3h2.8l-1 5.3h3.2v2.8zm-7.2 3h3.7l0.6-3h-3.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m398 413.8c3 2.5 6.8 3.9 10.7 3.8h86.7l-1.4 15.8h-187.7c-5.7 0.1-11.2-1.9-15.5-5.5-4.3-3.7-7.2-8.8-8-14.4l-26.8-172.2h111.6l24.8 162.5c0.6 3.9 2.6 7.5 5.6 10z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m292.3 413.8c3 2.6 6.9 3.9 10.8 3.8h115.1l-1.4 15.8h-120.9c-5.6 0.1-11.2-1.8-15.5-5.5-4.3-3.7-7.2-8.8-8-14.4l-25.3-162.5c-0.1-1.2 0-2.4 0.4-3.6 0.3-1.2 0.9-2.2 1.7-3.1 0.8-1 1.8-1.7 2.9-2.2 1.1-0.5 2.3-0.8 3.5-0.8h0.2c1.7 0 3.4 0.6 4.7 1.7 1.3 1.1 2.2 2.6 2.4 4.3l23.9 156.5c0.5 3.9 2.5 7.5 5.5 10z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m362.3 433.4v88.7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m312.6 530c0-2.1 0.8-4.1 2.3-5.6 1.5-1.5 3.5-2.3 5.6-2.3h83.7c2.1 0 4.1 0.8 5.6 2.3 1.5 1.5 2.3 3.5 2.3 5.6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m353.8 530c0-2.1 0.8-4.1 2.3-5.6 1.4-1.5 3.4-2.3 5.5-2.3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m320.5 537.9c0 1.5-0.4 3.1-1.3 4.4-0.9 1.3-2.1 2.3-3.6 2.9-1.4 0.6-3 0.8-4.5 0.5-1.6-0.4-3-1.1-4.1-2.2-1.1-1.1-1.9-2.5-2.2-4.1-0.3-1.5-0.1-3.1 0.5-4.6 0.6-1.4 1.6-2.6 2.9-3.5 1.3-0.9 2.9-1.3 4.4-1.3 2.1 0 4.1 0.8 5.6 2.3 1.5 1.5 2.3 3.5 2.3 5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.5
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m315.5 537.9c0 0.5-0.1 1.1-0.5 1.6-0.3 0.5-0.7 0.9-1.3 1.1-0.5 0.2-1.1 0.3-1.7 0.1-0.5-0.1-1-0.3-1.5-0.8-0.4-0.4-0.6-0.9-0.8-1.5-0.1-0.5 0-1.1 0.2-1.6 0.2-0.6 0.6-1 1.1-1.3 0.5-0.4 1-0.5 1.6-0.5 0.8 0 1.5 0.3 2.1 0.8 0.5 0.6 0.8 1.3 0.8 2.1z"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m361.7 537.9c0 1.5-0.5 3.1-1.3 4.4-0.9 1.3-2.1 2.3-3.6 2.9-1.4 0.6-3 0.8-4.6 0.5-1.5-0.4-2.9-1.1-4-2.2-1.1-1.1-1.9-2.5-2.2-4.1-0.3-1.5-0.2-3.1 0.4-4.6 0.7-1.4 1.7-2.6 3-3.5 1.3-0.9 2.8-1.3 4.4-1.3 2.1 0 4.1 0.8 5.6 2.3 1.5 1.5 2.3 3.5 2.3 5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.5
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m356.7 537.9c0 0.5-0.2 1.1-0.5 1.6-0.3 0.5-0.8 0.9-1.3 1.1-0.5 0.2-1.1 0.3-1.7 0.1-0.6-0.1-1.1-0.3-1.5-0.8-0.4-0.4-0.7-0.9-0.8-1.5-0.1-0.5 0-1.1 0.2-1.6 0.2-0.6 0.6-1 1.1-1.3 0.4-0.4 1-0.5 1.6-0.5 0.8 0 1.5 0.3 2 0.8 0.6 0.6 0.9 1.3 0.9 2.1z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m420 537.9c0 1.5-0.5 3.1-1.3 4.4-0.9 1.3-2.1 2.3-3.6 2.9-1.4 0.6-3 0.7-4.6 0.4-1.5-0.3-2.9-1-4-2.1-1.1-1.1-1.9-2.6-2.2-4.1-0.3-1.5-0.1-3.1 0.5-4.6 0.6-1.4 1.6-2.6 2.9-3.5 1.3-0.9 2.8-1.3 4.4-1.3 2.1 0 4.1 0.8 5.6 2.3 1.5 1.5 2.3 3.5 2.3 5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.5
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m415 537.9c0 0.5-0.2 1.1-0.5 1.6-0.3 0.5-0.8 0.8-1.3 1.1-0.5 0.2-1.1 0.2-1.7 0.1-0.5-0.1-1.1-0.4-1.5-0.8-0.4-0.4-0.7-0.9-0.8-1.5-0.1-0.5 0-1.1 0.2-1.6 0.2-0.6 0.6-1 1.1-1.3 0.4-0.4 1-0.5 1.6-0.5 0.8 0 1.5 0.3 2 0.8 0.6 0.6 0.9 1.3 0.9 2.1z"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m449.6 258.7l28.3-42.2 8.7 1.8c-6.7 22.6-11.1 31.5-11.1 31.5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m474.6 222.1l4.6-8.3c0.7-1.5 1.7-2.7 2.9-3.6 1.3-1 2.7-1.6 4.3-1.8 3-0.4 8.4 0 10.1-0.4 1.7-0.4 5.3-7.1 7.1-7 0.8 0.1 1.1 5.4 0.4 7.2-1.1 2.8-3.2 5.2-5.9 6.6-3.1 1.6-11.5 3.5-11.5 3.5l-4.5 7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m468.1 228.9l4.9-7.2 12.9 5.7-4.1 11"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m364.9 213.8c0 0 20.9-9.6 39.4 6.8 18.4 16.4 30.9 31.7 37.7 36.6l27.8-32 15.5 7.3c-4.1 23.2-15.6 60.1-43.7 63.9-30.4 4.1-75-33.4-75-33.4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m432.9 267.8l9.1-10.6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m487.9 532.4l18.7 7.6c0.7 0.2 1.2 0.5 1.5 1 0.4 0.6 0.6 1.2 0.6 1.8 0 0.8-0.3 1.5-0.8 2.1-0.6 0.6-1.4 0.9-2.2 0.9h-27.3q-0.8 0-1.5-0.4-0.8-0.3-1.3-1-0.4-0.6-0.6-1.4-0.2-0.8 0-1.6l2.4-9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m497.9 400.9c-5.1 40.8-10 131.5-10 131.5-5.7 5.8-10.5 0-10.5 0 0 0-20.2-95.1-15.8-141.1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m396.3 337.6l31.4 16.4v0.3c0 0 64.1-4.3 73.8 18.6 15.1 35.9 17.8 152.4 17.8 152.4h-46.9c0 0-17.5-97.9-23.5-103.8-5.9-6-30.5-5.6-75.8-5.6-50.8 0-26-65.5-7.1-71.1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m379.8 413.8c0-0.1 59.1-6 71.6 3.1 10.3 7.4 24.2 108.4 24.2 108.4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m389.6 532.4l18.7 7.6c0.6 0.2 1.1 0.5 1.5 1 0.4 0.6 0.6 1.2 0.6 1.8 0 0.8-0.3 1.5-0.9 2.1-0.6 0.6-1.3 0.9-2.1 0.9h-27.4q-0.8 0-1.5-0.4-0.7-0.3-1.2-1-0.5-0.6-0.7-1.4-0.1-0.8 0.1-1.6l2.3-9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m411.2 400.9c-5.1 40.8-21.6 131.5-21.6 131.5-5.8 5.8-10.6 0-10.6 0 0 0 0.2-95.1 4.6-141.1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m340.9 352c0 0 82.4 1.3 93.2 26.3 13.2 30.7-8.6 147.1-8.6 147.1h-49.7v-104.1c0.1-1-0.3-1.9-1-2.6-0.7-0.8-1.6-1.2-2.6-1.2-6.8 0.2-22.2 0.2-41.7 0.2-50.8 0-26-79.1-7-84.8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m340.9 352c0 0 82.4 1.3 93.2 26.3 3.6 8.3 5.4 22.4 4.5 39.3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m328.5 332.9c-18.9 5.7-39.6 78.5 11.2 78.5 26.5 0 37.8-3.9 41.2 3.9 2.4 5.5 1.9 110 1.9 110"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m339.3 339.5c0 0 4 17.9 0 21.9-3.9 3.9-30 3.3-30 3.3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m343 343c0 0 4.5 17.9 0 21.9-4.6 3.9-34.4 3.3-34.4 3.3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m354.2 208.7c13.6-3.2 44.5 30.2 44.5 30.2 20.8 20.1 35.2 115.1 29 115.1-6.1 0-111.4 0.3-120.9 0.3-9.4 0-3.2-111.1-3.2-111.1 0 0 37-31.3 50.6-34.5z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m421 293.8l-13-53.6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m224.4 254.4c0 0-4.4-8.9-11.1-31.5l8.8-1.8 28.3 42.3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m217.8 229.9l-4.5-7c0 0-8.4-1.9-11.4-3.5-2.8-1.4-4.9-3.8-6-6.6-0.6-1.8-0.3-7.1 0.4-7.2 1.8-0.2 5.4 6.6 7.1 7 1.7 0.4 7.2 0 10.2 0.4 1.5 0.2 3 0.8 4.2 1.8 1.3 0.9 2.3 2.1 3 3.6l4.6 8.3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m218.1 243l-4-11 12.8-5.7 5 7.2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m337.9 255.8c0 0-45.1 51.5-67.1 51.5-28 0-46.7-44.6-55.3-70.8l13.6-7.3c11.5 15 30.6 39.4 33.7 39.4 4.5 0 17.8-34 37.7-50.8 21.3-18.1 42-3.4 42-3.4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m301.8 290.8l33.4-27.8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m367 213.7l-2.6 24.7-19.9-21.3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m367 213.7l-2.6 24.7-19.9-21.3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m360.5 195.5l5.6 12.3c0 0 2.2 7-7.1 10.2-2.8 1.1-5.9 1.3-8.8 0.6-2.9-0.6-5.6-2.1-7.7-4.2l-1.5-19.2"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m342 207.4c0 0 7.3 9.2 17 10.6l-7 10.4c-5.7-3.2-12.7-15.6-12.7-15.6z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m368.6 212.5c0 0 0.2 7-1.6 11.6l-8-6.1c3.2-3.3 5.5-7.4 6.5-11.9z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m368.8 175.7c0 0 5.3 20.3-2.7 25.4-7.9 5.1-21.7-2.7-22.5-5.2-0.8-2.6-4.4-24.2 0.8-25.8 9.2-2.9 21.7-3 24.4 5.6z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m368.6 182.3q0.1 0.3 0 0.6-0.1 0.3-0.4 0.5-0.3 0.2-0.6 0.2-0.3 0-0.6-0.2-0.2-0.1-0.4-0.4-0.1-0.3 0-0.6 0-0.3 0.2-0.6 0.3-0.2 0.6-0.3 0.2 0 0.4 0 0.2 0.1 0.3 0.2 0.2 0.1 0.3 0.2 0.2 0.2 0.2 0.4z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m366.8 176.3c0.4 0 1.9 0.2 1.6 0.9-0.1 0.4-0.7 0.4-1 0.4q-0.5-0.1-0.9 0 0.1 0.1 0.2 0.3c0.1 0.2-0.7 0.2-0.8 0.2-0.9-0.1-1.8 0.1-2.6 0.5 0.3-0.7 0.7-1.3 1.4-1.8 0.6-0.4 1.4-0.6 2.1-0.5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m356.1 184.3q0.3-0.3 0.8-0.3 0.3 0 0.5 0.1 0.3 0.2 0.5 0.5 0.1 0.3 0 0.6 0 0.3-0.2 0.5-0.2 0.3-0.5 0.3-0.3 0.1-0.6 0-0.3-0.1-0.5-0.3-0.2-0.3-0.2-0.6 0-0.4 0.2-0.8z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m356.2 179.9q0.7-0.4 1.4-1c-0.1 1-0.6 1.9-1.3 2.6-0.6 0.7-1.5 1.1-2.5 1.2q0-0.2 0.1-0.5 0.1-0.2 0.3-0.4-0.9 0.3-1.7 0.9c-0.3 0.2-0.8 0.5-0.9-0.1-0.1-0.6 0.5-1.2 1.2-1.6 1.1-0.5 2.3-0.5 3.4-1.1z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m363.5 183.5c0 0 2.8 7.1 1.8 7.7-1 0.6-4.6 0.5-4.6 0.5"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m363.6 202.2c-2.6 0.9-5.3 1.1-7.9 0.7-2.6-0.4-5.1-1.5-7.2-3.1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m359 197.5c0 0 0.7-3.1 5.9-3.1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m370.6 173.9c-1.7 1.5-4.1 1.8-6.4 2.2q-7.6 1.1-15.1 2.7c0.2 3.5 0.4 7 0.8 10.5q0.1 0.3 0 0.6-0.1 0.3-0.3 0.4-0.2 0.2-0.5 0.2c-1 0.2-1.9-0.7-2.8-1.2 0.3 1.5 0.4 3.1 0.3 4.6q-0.1 0.7-0.4 1.3-0.3 0.7-0.8 1.2c-0.8 0.4-1.8 0.6-2.7 0.4-5-0.5-5.8-7.6-6.4-11.3q-0.9-5-1.1-10.1c-0.1-1.9 0.2-3.8 0.9-5.5 1-2 2.5-3.6 4.3-4.7q2.8-1.7 5.9-2.7c4.1-1.6 8.3-3.1 12.7-3.1 1 0 2.7-0.7 3.5 0.4 0.7 1.1-0.8 2.1-1.5 2.6l-2.6 2.3c3.2-2.3 7-3.5 10.9-3.5q0.8-0.1 1.6 0.2 0.8 0.2 1.5 0.8c0.6 0.8 0.9 1.7 0.9 2.7 0.2 3.2-0.2 6.9-2.7 9z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m349.1 194.5c-0.7 1.6-1.6 3.5-3.2 3.7-3.3 0.5-5.8-4.7-4.7-8.1 0.2-1 0.7-1.9 1.5-2.6 2.3-1.4 3.8 1.1 4.6 3.1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m650.3 411.5c0-8.3 2.5-16.4 7.3-23.2 4.7-6.8 11.4-12 19.2-14.8 2.9-1.1 16.6-2.1 16.6-2.1 0 0-1.6 10.5-4.3 15.8-6.4 12.3-19 22.7-38.8 24.3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m690.8 442.8c5-6.2 12.1-10.4 19.9-11.8 7.8-1.4 15.9 0 22.8 3.9q0.3 0.2 0.5 0.6 0 0.2-0.1 0.4-0.1 0.2-0.3 0.4c-3.2 3.5-7.2 6.3-11.7 8.1-4.5 1.7-9.3 2.4-14.1 1.9q-8.7-1.1-17-3.5z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m701.8 426c0-9.6 3.2-18.2 8.9-23.8 2.9-2.8 6.4-5 10.2-6.2 3.9-1.3 8-1.6 12-1.1q0.5 0.1 0.8 0.4c0.3 0.3 0.3 0.7 0.3 1.1-0.5 11.6-6.3 21.1-15.1 25-5.5 2.1-11.2 3.7-17.1 4.6"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m716.7 408.9c3.9-6.2 8.5-11.8 13.8-16.7 2.1-2 4.4-3.7 6.9-5.2 8.3-4.4 18.5-3 27.4 0-3.6 6.7-8.2 13.3-15 16.7-3 1.4-6.2 2.4-9.5 3.1-6.5 1.4-16.9 1.3-23.5 2.1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m712 392.8c-16.5-8.6-19-26.7-19.4-33.3-0.3-4.2 0-8.9 3.5-11.9 20.5 7.2 25.7 21.1 15.9 45.3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m637.3 385.6c-8.1-2.6-14.9-8-19.3-15.2-4.4-7.2-6.1-15.8-4.6-24.1 7.7 0 14.7 4.6 20.1 10.1 2.3 2.2 4.2 4.8 5.7 7.6 4 8 2.8 17.4 1.5 26.2"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m688.8 447.8c-4.6-1.5-8.9-4-12.5-7.3-3.6-3.2-6.6-7.2-8.6-11.6-2.1-4.5-3.2-9.3-3.3-14.2-0.1-4.9 0.8-9.7 2.6-14.2q0.1-0.4 0.3-0.6 0.2-0.3 0.5-0.4 0.3-0.1 0.6 0 0.3 0.1 0.6 0.3c14.2 8.2 24 32 19.8 48"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m650.1 399.2c-2.7-7.7-2.6-16.2 0.3-23.9 3-7.7 8.5-14.1 15.7-18.1 2.9-1.6 6.1-2.8 8.7-4.9q1.3 5.8 1.7 11.7c0.5 3.9 0.2 7.9-0.7 11.7-2.7 9.8-11.7 16.4-20.8 21"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m638.1 397.7c-14.8 1.8-33.1-4.2-41.1-18.2 25.4-12.9 41.1 6.9 41.1 18.2z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m644.9 431.4c-9.5 0.7-19 1.2-28.3-0.9-9.2-2-18.3-6.8-24-15.1q-0.3-0.3-0.3-0.7 0-0.4 0.2-0.7 0.2-0.4 0.5-0.6c4.1-3.7 9.2-6.3 14.7-7.4 5.4-1.2 11.1-1 16.4 0.7 10.6 3.4 19.3 12.7 22.7 24.1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m627.6 370c-0.1-0.1 0.1-0.4 0.3-0.2 7.4 6.9 12.2 15.8 15.7 25.3 4.1 10.9 7.2 22.1 9.4 33.5 4.6 23.5 7.4 47.3 8.3 71.2 0 0.3-0.5 0.3-0.5 0-2.7-23.4-3.9-46.7-8.5-69.8-2.1-11-4.9-21.8-8.6-32.3-3.5-10.2-8.3-20-16-27.7z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m654.5 440.7c-13.4-18.8-38.1-24-59.8-25q-0.1 0-0.1-0.1-0.1 0-0.1-0.1 0-0.1 0.1-0.1 0-0.1 0.1-0.1c11.8-0.8 24.3 2 35.3 6.4 9.8 4 19.3 9.5 25 18.7 0.2 0.3-0.3 0.6-0.5 0.3z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m650.5 418.7c-0.1-8.6-1-17.4 0.7-26 1.6-7.9 4.8-15.4 9.6-21.9 0.1-0.2-0.2-0.4-0.3-0.3-11.7 13.1-11.8 31.8-10.3 48.2 0 0.2 0.3 0.2 0.3 0z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m616.1 384.3c-0.1 0-0.1-0.1 0-0.1 5.8 0.5 11 4.1 15.5 7.6q8.1 6.3 15.3 13.6c0.2 0.2-0.1 0.4-0.3 0.3-4.7-4-9-8.5-13.8-12.4-4.8-3.9-10.4-8.2-16.8-9z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m683 469.6c3.5-18.1 10.8-34.7 22.9-48.7 5.8-6.8 12.5-12.8 19.9-17.8 7.7-5.3 16-8.8 24.7-12.1q0.1-0.1 0.2-0.2 0-0.1 0-0.2 0-0.1-0.2-0.2-0.1 0-0.2 0c-17.5 4.6-33.7 16.7-45.3 30.3-11.6 13.7-20.3 30.9-22.4 48.8 0 0.3 0.4 0.3 0.4 0z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m703.6 361.3c8.6 17.2 13.8 40.9 3.2 58.4q-0.1 0.2-0.2 0.2-0.1 0-0.2 0-0.2-0.1-0.2-0.2 0-0.2 0-0.3c8.8-18.8 5.6-39.6-3.1-57.8-0.1-0.3 0.3-0.6 0.5-0.3z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m714.4 457.6v14.4c0 57.5-15.1 73.8-15.1 73.8h-46.8c0 0-15.1-16.3-15.1-73.8v-14.4z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m211.8 545.8l39.7-190.4"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m291.2 545.8l-39.7-190.4"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m612.7 545.8l39.7-190.4"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m692.1 545.8l-39.7-190.4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m687.2 355.4h-474.1v-11.3h474.1z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m664.4 322.4h-167.5q-1.1 0-2.1-0.5-0.9-0.4-1.6-1.3-0.7-0.8-1-1.8-0.2-1-0.1-2.1l19.3-108.3c0.3-1.6 1.2-3.1 2.4-4.2 1.3-1.1 3-1.7 4.7-1.7h167.5q1 0 2 0.4 1 0.5 1.7 1.3 0.6 0.8 0.9 1.9 0.3 1 0.1 2l-19.2 108.3c-0.3 1.7-1.2 3.2-2.5 4.3-1.3 1.1-2.9 1.7-4.6 1.7z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m668.3 322.4h-167.6q-1.1 0-2-0.5-1-0.4-1.7-1.3-0.7-0.8-0.9-1.8-0.3-1-0.1-2.1l19.2-108.3c0.3-1.6 1.2-3.1 2.5-4.2 1.3-1.1 2.9-1.7 4.6-1.7h167.6q1 0 2 0.4 1 0.5 1.7 1.3 0.7 0.8 0.9 1.9 0.3 1 0.1 2l-19.3 108.3c-0.2 1.7-1.1 3.2-2.4 4.3-1.3 1.1-2.9 1.7-4.6 1.7z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m637.4 322.4h-96.7q-0.7 0-1.2-0.3-0.6-0.3-1-0.7-0.4-0.5-0.5-1.1-0.2-0.6-0.1-1.2l11.2-62.5c0.1-1 0.6-1.9 1.4-2.5 0.7-0.6 1.7-1 2.6-1h96.8q0.6 0 1.2 0.3 0.6 0.3 1 0.7 0.3 0.5 0.5 1.1 0.2 0.6 0.1 1.2l-11.2 62.5c-0.2 0.9-0.7 1.8-1.4 2.5-0.7 0.6-1.7 0.9-2.7 1z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m639.8 322.4h-96.8q-0.6 0-1.2-0.3-0.5-0.3-0.9-0.7-0.4-0.5-0.6-1.1-0.2-0.6 0-1.2l11.1-62.5c0.1-1 0.6-1.9 1.4-2.5 0.7-0.6 1.7-1 2.7-1h96.7q0.7 0 1.2 0.3 0.6 0.3 1 0.7 0.4 0.5 0.5 1.1 0.2 0.6 0.1 1.2l-11.2 62.5c-0.1 1-0.6 1.9-1.4 2.5-0.7 0.6-1.7 1-2.6 1z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m618.3 322.4h-39.3v-36.8h39.3z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s7",
    d: "m628.4 338.1h-39.3l-10.1-42v-10.5h37.1zm-16.4-22.7c-1.3-6.3-6-11.4-10.4-11.4-4.4 0-6.9 5.1-5.5 11.4 1.3 6.3 6 11.5 10.4 11.5 4.4 0 6.9-5.1 5.5-11.5z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m557.4 338.1h88v6h-93.9c0-1.6 0.6-3.1 1.7-4.3 1.1-1.1 2.7-1.7 4.2-1.7z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m645.4 344.1h-70.4v-6h70.4z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m630.7 338.1h-39.3l-12.4-52.5h39.3zm-16.4-22.7c-1.4-6.3-6-11.4-10.4-11.4-4.4 0-6.9 5.1-5.6 11.4 1.4 6.3 6 11.5 10.4 11.5 4.4 0 6.9-5.1 5.6-11.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.7
    }
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m528.9 213.2l-2.3 13h-2.4l2.4-13z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m535.6 213.2l-2.3 13h-2.3l2.3-13z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m542.4 213.2l-2.4 13h-2.3l2.3-13z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m549.1 213.2l-2.3 13h-2.4l2.4-13z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m555.8 213.2l-2.3 13h-2.3l2.3-13z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.7
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m617.3 213.2l-2.3 13h-2.4l2.4-13z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m624.4 213.2l-2.3 13h-2.4l2.4-13z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m631.5 213.2l-2.4 13h-2.3l2.3-13z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m638.5 213.2l-2.3 13h-2.3l2.3-13z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m645.6 213.2l-2.3 13h-2.3l2.3-13z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m652.7 213.2l-2.3 13h-2.4l2.4-13z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m659.8 213.2l-2.4 13h-2.3l2.3-13z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m666.8 213.2l-2.3 13h-2.3l2.3-13z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m673.9 213.2l-2.3 13h-2.3l2.3-13z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m681 213.2l-2.3 13h-2.3l2.3-13z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.5
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m346.6 314.4c0.6-0.1 1.2-0.4 1.6-0.8 0.9-1.3-0.6-2.6-1.6-3.3-1.2-0.8-3-1.1-3.6-2.6-0.7-1.6 0.5-3.7 1.9-4.7q1.9-1.1 4-1.7c1.6-0.5 3-1.6 4-3 1.1-1.7 0.9-4 1-6.1 0.6-7.8 8.7-11.8 15.5-11.9 3.4-0.1 8.6 1.1 10.8 3.8 0.8 0.8 1.3 1.9 1.6 3 0.1 0.9 0 1.8-0.2 2.6-0.3 0.8-0.7 1.6-1.3 2.2q-2 1.8-4.1 3.3c-1.3 1.2-0.4 2.6-0.7 4-0.3 1.5-1.4 2.4-2.8 3.2-3 1.7-6.6 2.1-9.9 3q-1.6 0.3-2.9 1.2-1.4 1.5-2.5 3.3c-1.5 2-3.7 3.4-6.1 3.9"
  }))), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m365.5 334.3h-6.4v-3.1h6.4q0.8 0 1.5-0.3 0.7-0.3 1.2-0.8 0.5-0.5 0.8-1.2 0.3-0.7 0.3-1.4v-5.3q0-0.8-0.3-1.5-0.3-0.7-0.8-1.2-0.5-0.5-1.2-0.8-0.7-0.3-1.5-0.2h-6.4v-3.1h6.4c1.8 0 3.6 0.7 4.9 2 1.2 1.3 2 3 2 4.8v5.3c-0.1 1.8-0.8 3.5-2.1 4.8-1.2 1.2-3 1.9-4.8 2z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m337.9 310.9h26v23.9c0 2-0.8 3.9-2.2 5.3-1.5 1.4-3.4 2.2-5.4 2.2h-10.8c-2.1 0-4-0.8-5.4-2.2-1.4-1.4-2.2-3.3-2.2-5.3v-23.9z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m368.2 337.9c0 0-0.3 6.2-9.8 6.2h-14.9c-9.5 0-9.8-6.2-9.8-6.2z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m542.6 344.1h-137.5v-2.5h137.5z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m419.7 341.6h-9.9v-1.9h9.9z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m434.6 341.6h-9.9v-1.9h9.9z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m449.5 341.6h-9.9v-1.9h9.9z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m464.4 341.6h-9.8v-1.9h9.8z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m479.3 341.6h-9.8v-1.9h9.8z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m494.3 341.6h-9.9v-1.9h9.9z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m509.2 341.6h-9.9v-1.9h9.9z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m524.1 341.6h-9.9v-1.9h9.9z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m539 341.6h-9.8v-1.9h9.8z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m544.4 344.1h-137.5v-2.5h137.5z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m421.5 341.6h-9.9v-1.9h9.9z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m436.4 341.6h-9.9v-1.9h9.9z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m451.3 341.6h-9.9v-1.9h9.9z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m466.2 341.6h-9.8v-1.9h9.8z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m481.1 341.6h-9.8v-1.9h9.8z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m496.1 341.6h-9.9v-1.9h9.9z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m511 341.6h-9.9v-1.9h9.9z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m525.9 341.6h-9.9v-1.9h9.9z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m540.8 341.6h-9.8v-1.9h9.8z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m206.7 434.6c-8-3.3-16.3-8.3-19.3-16.5-1-3.2-1.6-6.5-1.5-9.9q0-5.1 0.7-10.2c2.3 1.6 5.1 2.4 7.7 3.6 6.5 2.8 11.7 7.9 14.8 14.3 3.1 6.3 3.8 13.6 2.1 20.4"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m212.2 458.2c0.2-15.8 0.4-33.8-12-45.6q-0.1 0-0.1 0-0.1 0-0.2 0 0 0.1 0 0.2 0 0 0 0.1c5.7 6.4 9.4 14.4 10.8 22.8 1 7.5 0.6 15 1.2 22.5q0 0.1 0 0.1 0.1 0.1 0.1 0.1 0.1 0 0.1-0.1 0.1 0 0.1-0.1z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m192 478.9c-17 0.9-28.8-6.6-35.6-16.4-3-4.2-5.4-13-5.4-13 0 0 11.8-0.6 14.3 0 4.6 1 8.9 3 12.7 5.7 3.8 2.8 7 6.4 9.4 10.5 2.4 4 4 8.6 4.6 13.3"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m181.7 448.8c-4.1-3.1-11.1-6.9-14.9-10.4q-3-2.5-5.3-5.7c-3.3-4.9-4-11.2-3.9-17.2 7 1.3 14.4 4.2 18.3 10.4q1.7 2.9 2.7 6.1c1.7 5.5 2.8 11.1 3.1 16.7"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m221.6 428.1c-1.1-7.6-2.2-15.7 1.3-22.5 1.3-2.5 2.9-4.7 4.9-6.6 4.6-4.7 10.7-8.6 17.3-8.6 1.2 7.1-0.2 14.5-4 20.7-3.7 6.1-12.6 14.8-19.5 17"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m239.9 448.8q0.2-0.1 0.5 0 0.2 0 0.4 0.2 0.1 0.2 0.1 0.4 0.1 0.3 0 0.5c-0.5 3.6-1.8 7-3.6 10.1-1.9 3-4.4 5.7-7.4 7.8-2.9 2-6.3 3.5-9.8 4.2-3.5 0.7-7.2 0.7-10.7 0 3.3-11.7 18.3-23.3 30.5-23.2z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m185.2 423.3c3.2-3.8 8.6-8.2 15.8-7.8-0.1 12.2-6.6 23.5-16.6 29.2-3.9-6.6-3.6-16 0.8-21.4z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m191.7 464.5c-1.4-3.4-1.9-7-1.5-10.6 0.4-3.6 1.6-7 3.7-10 2-3 4.7-5.5 7.9-7.2 3.1-1.7 6.7-2.6 10.3-2.6 0.3 0 0.6 0 0.8 0.3q0.1 0.2 0.1 0.5c0.3 6.2-2.4 12.1-6.3 16.9-3.8 4.8-8.9 8.5-13.9 12.1"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m232.8 410.7c-13.2 13.3-17.7 33.8-21.2 51.5-3.9 19.9-4.8 39.9-7.2 59.9-0.1 0.4-0.6 0.4-0.6 0 0.7-20.6 3.1-41.1 7.2-61.3 3.5-17.3 8.2-37.6 21.5-50.3 0.2-0.2 0.4 0.1 0.3 0.2z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m191.1 475.1c-0.9-5.3-0.2-12.6 2.3-17.4q0.1-0.1 0.1-0.1 0.1-0.1 0.2 0 0.1 0 0.1 0.1 0 0 0 0.1c-1.5 5.6-2.2 11.4-2.1 17.3 0 0.3-0.6 0.4-0.6 0z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m192.5 423.9c0.1 0 0.1 0.1 0.1 0.1-8.1 7.9-8.9 21.9-6.5 32.2q0 0 0 0.1-0.1 0.1-0.1 0.1-0.1 0-0.2 0-0.1-0.1-0.1-0.1c-3.2-9.9-1.2-25.1 6.8-32.4z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m195.4 510q0 0-0.1 0.1 0 0-0.1 0-0.1 0-0.2 0 0-0.1 0-0.1c-0.9-13.9-2-27.5-5.7-40.9-2-7.1-4.6-13.9-8-20.4-3.4-6.2-7.4-12.1-11.9-17.5-0.3-0.3 0.1-0.7 0.4-0.4 10 9.6 16.1 24 19.9 37.1 4 13.7 6 27.8 5.7 42z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m236.3 485.6v9.9c0 39.2-13 50.3-13 50.3h-40.2c0 0-13-11.1-13-50.3v-9.9z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m148 545.8h631"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/Not_found.a40c52d81d93eeddb1897b53612c10e4.svg";
export { ForwardRef as ReactComponent };